import { TokenResponse } from '@openid/appauth/built';
import { Apps } from '@/constants/apps';

enum StorageKey {
  RESPONSE = 'auth/response',
  STATE = 'auth/state',
}

export default class OAuthStorage {
  private storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  storeResponse(appName: Apps, response: TokenResponse) {
    const value = JSON.stringify(response.toJson());

    this.storage.setItem(`${appName}:${StorageKey.RESPONSE}`, value);
  }

  storeState(appName: Apps, state: string) {
    this.storage.setItem(`${appName}:${StorageKey.STATE}`, state);
  }

  retrieveResponse(appName: Apps): TokenResponse | null {
    const item = this.storage.getItem(`${appName}:${StorageKey.RESPONSE}`);
    const response = item && JSON.parse(item);

    if (!response) {
      return null;
    }

    return new TokenResponse(response);
  }

  retrieveState(appName: Apps) {
    return this.storage.getItem(`${appName}:${StorageKey.STATE}`);
  }

  clearResponse(appName: Apps) {
    this.storage.removeItem(`${appName}:${StorageKey.RESPONSE}`);
  }

  clearState(appName: Apps) {
    this.storage.removeItem(`${appName}:${StorageKey.STATE}`);
  }

  clear(appName: Apps) {
    this.clearResponse(appName);
    this.clearState(appName);
  }
}
